/*
 * Copyright 2025 Intuition Robotics ltd
 */
// const daysShort = Days.DAYS
//                       .map(day => day.charAt(0).toUpperCase() + day.slice(1, 3).toLowerCase());
import dayjs from "../../../utils/dayjs";
import {AlertStatus} from "@app/app-shared/alert";

function getFormattedDate(diff: number, month: number, date: number, year: number) {
	if (diff < 0)
		return ` ${month}/${date}`;

	if (diff < 86400000)
		return "Today";

	if (diff < 2 * 86400000)
		return "Yesterday";

	let dateToReturn = ` ${month}/${date}`;

	if (year < dayjs().year())
		dateToReturn = `${dateToReturn}/${year}`;

	return dateToReturn;
}

export const formatAlertDatetime = (timestamp: number) => {

	const dt = dayjs(timestamp);

	const hours = dt.hour();
	const minutes = dt.minute();
	const date = dt.date();
	const month = dt.month() + 1;
	const year = dt.year();
	// const day = dt.getDay();

	const now = dayjs().startOf("day");

	const diff = now.valueOf() - dt.startOf('day').valueOf();
	const formattedDate = getFormattedDate(diff, month, date, year);

	return {
		date: formattedDate,
		time: `${hours < 10 ? `${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}`
	};

};


export const formatStatus = (status: AlertStatus) => {
	const lowerStatus = status.toString().toLowerCase();
	switch (status) {
		case AlertStatus.NEW:
			return "Unread"
		case AlertStatus.IN_PROGRESS:
			return "In progress";
		default:
			return (lowerStatus.charAt(0).toUpperCase() + lowerStatus.slice(1)).replace('_', ' ');
	}
};
